import * as Types from './@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GoGoLiveParentGuideListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GoGoLiveParentGuideListQuery = { __typename?: 'Query', goGoLiveParentGuideList: Array<{ __typename?: 'GoGoLiveParentGuideInfo', goGoLiveParentGuideId: number, yearAndMonth: string, levelName: string, previewVideoVimeoId: string, previewVideoUrl: string }> };


export const GoGoLiveParentGuideListDocument = gql`
    query GoGoLiveParentGuideList {
  goGoLiveParentGuideList {
    goGoLiveParentGuideId
    yearAndMonth
    levelName
    previewVideoVimeoId
    previewVideoUrl
  }
}
    `;

/**
 * __useGoGoLiveParentGuideListQuery__
 *
 * To run a query within a React component, call `useGoGoLiveParentGuideListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoGoLiveParentGuideListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoGoLiveParentGuideListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGoGoLiveParentGuideListQuery(baseOptions?: Apollo.QueryHookOptions<GoGoLiveParentGuideListQuery, GoGoLiveParentGuideListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoGoLiveParentGuideListQuery, GoGoLiveParentGuideListQueryVariables>(GoGoLiveParentGuideListDocument, options);
      }
export function useGoGoLiveParentGuideListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoGoLiveParentGuideListQuery, GoGoLiveParentGuideListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoGoLiveParentGuideListQuery, GoGoLiveParentGuideListQueryVariables>(GoGoLiveParentGuideListDocument, options);
        }
export type GoGoLiveParentGuideListQueryHookResult = ReturnType<typeof useGoGoLiveParentGuideListQuery>;
export type GoGoLiveParentGuideListLazyQueryHookResult = ReturnType<typeof useGoGoLiveParentGuideListLazyQuery>;
export type GoGoLiveParentGuideListQueryResult = Apollo.QueryResult<GoGoLiveParentGuideListQuery, GoGoLiveParentGuideListQueryVariables>;